// extracted by mini-css-extract-plugin
module.exports = {"undoStyle":"_2wr_IEGZSpLkGGuDF1HHVO"};